import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export type ProjectMode = 'operation' | 'manage';

interface ProjectModeToggleProps {
  currentMode: ProjectMode;
  onModeChange: (mode: ProjectMode) => void;
}

const ToggleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  backgroundColor: '#f5f5f5',
  borderRadius: '12px',
  padding: '4px',
  position: 'relative',
  border: '1px solid #e0e0e0',
  width: 'fit-content',
}));

const ToggleButton = styled(Box)<{ active: boolean }>(({ theme, active }) => ({
  padding: '8px 24px',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  backgroundColor: active ? '#1976d2' : 'transparent',
  color: active ? '#ffffff' : '#666666',
  fontWeight: active ? 600 : 400,
  fontSize: '14px',
  textAlign: 'center',
  minWidth: '80px',
  userSelect: 'none',
  '&:hover': {
    backgroundColor: active ? '#1565c0' : '#e3f2fd',
  },
}));

export const ProjectModeToggle: React.FC<ProjectModeToggleProps> = ({
  currentMode,
  onModeChange,
}) => {
  return (
    <ToggleContainer>
      <ToggleButton
        active={currentMode === 'operation'}
        onClick={() => onModeChange('operation')}
      >
        <Typography variant="body2" component="span">
          Operation
        </Typography>
      </ToggleButton>
      <ToggleButton
        active={currentMode === 'manage'}
        onClick={() => onModeChange('manage')}
      >
        <Typography variant="body2" component="span">
          Manage
        </Typography>
      </ToggleButton>
    </ToggleContainer>
  );
};